var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 55,
    viewBox: "0 0 42 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12464_18602)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1205 29.1595C35.9353 26.5647 37 23.4067 37 20C37 11.1634 29.8366 4 21 4C12.1634 4 5 11.1634 5 20C5 23.4067 6.06469 26.5647 7.87947 29.1595C7.90139 29.2943 7.95236 29.4285 8.03647 29.5547L20.1679 47.7519C20.5638 48.3457 21.4362 48.3457 21.832 47.7519L33.9635 29.5547C34.0476 29.4285 34.0986 29.2943 34.1205 29.1595Z",
    fill: "#6AD400"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12464_18602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12464_18602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7497 22.5H22.2497L21.7705 19.8125C22.0483 19.6736 22.267 19.4722 22.4268 19.2083C22.5865 18.9444 22.6663 18.6527 22.6663 18.3333C22.6663 17.875 22.5031 17.4826 22.1768 17.1562C21.8504 16.8298 21.458 16.6666 20.9997 16.6666C20.5413 16.6666 20.149 16.8298 19.8226 17.1562C19.4962 17.4826 19.333 17.875 19.333 18.3333C19.333 18.6527 19.4129 18.9444 19.5726 19.2083C19.7323 19.4722 19.9511 19.6736 20.2288 19.8125L19.7497 22.5ZM20.9997 28.3333C19.0691 27.8472 17.4754 26.7395 16.2184 25.0104C14.9615 23.2812 14.333 21.3611 14.333 19.25V14.1666L20.9997 11.6666L27.6663 14.1666V19.25C27.6663 21.3611 27.0379 23.2812 25.7809 25.0104C24.524 26.7395 22.9302 27.8472 20.9997 28.3333ZM20.9997 26.5833C22.4441 26.125 23.6386 25.2083 24.583 23.8333C25.5275 22.4583 25.9997 20.9305 25.9997 19.25V15.3125L20.9997 13.4375L15.9997 15.3125V19.25C15.9997 20.9305 16.4719 22.4583 17.4163 23.8333C18.3608 25.2083 19.5552 26.125 20.9997 26.5833Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12464_18602",
    x: 0,
    y: 0,
    width: 42,
    height: 54.1973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12464_18602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12464_18602",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.57ae938047b65c15dfd65539caebdb18.svg";
export { ForwardRef as ReactComponent };